import React from 'react';
import Editor from '../../Editor';
import { EditorProps } from '../../types';
import cn from 'classnames';
import { extConfig } from './config';

import viewerStyles from '../../../Viewer/presets/Literature/Literature.scss';
import s from './Literature.scss';

const LiteratureEditor: React.FC<
  Omit<EditorProps, 'extensionConfig' | 'presetId'>
> = props => {
  return (
    <Editor
      {...props}
      withinModal
      presetId="journal"
      className={cn(s['root'], viewerStyles['root'])}
      extensionConfig={extConfig}
    ></Editor>
  );
};
LiteratureEditor.displayName = 'LiteratureEditor';

export default LiteratureEditor;
